import {BarcodeFormat} from '@capacitor-mlkit/barcode-scanning';
import {isValidProductBarcode} from '../barcode/product-barcode';
import {extractQrToken} from '../qr-scanner/extract-qr-token';

export type SearchIntent = 'text' | 'qr' | 'barcode';
export type CodeScan = {value: string; type: 'qr' | 'barcode'; format: BarcodeFormat};
export const universalFormats = [BarcodeFormat.QrCode, BarcodeFormat.Ean8, BarcodeFormat.Ean13, BarcodeFormat.UpcA];

export function toCodeScan(rawValue: string, format: BarcodeFormat): CodeScan | null {
  if (!universalFormats.includes(format)) return null;
  if (format === BarcodeFormat.QrCode) {
    try {
      const value = extractQrToken(rawValue);
      return value ? {value, type: 'qr', format} : null;
    } catch { return null; }
  }
  const value = rawValue.trim();
  return value && isValidProductBarcode(value) ? {value, type: 'barcode', format} : null;
}
